import { projectDataType } from ".";

const dnsData: projectDataType = {
  path: "dns",
  title: "Dimensional Navigation Simulator",
  coverImage:
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684965184/Art-Site/DNS/dns-sunset.jpg",
  description:
    "A fictional commercial for a dimensional navigation simulartor.",
  year: 2012,
  videos: ["https://vimeo.com/53656622"],
  projectPhotos: [
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684965184/Art-Site/DNS/dns-sunset.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684965183/Art-Site/DNS/ascreen_shot_2013-03-25_at_70214_pm_cl4b5j.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684965184/Art-Site/DNS/dns-3.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684965184/Art-Site/DNS/dns-2.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684965183/Art-Site/DNS/dns-7.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684965184/Art-Site/DNS/dns-5.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684965183/Art-Site/DNS/dns-9.jpg",
  ],
};

export default dnsData;
